import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Contact from "../views/Contact.vue";
import Trends from "../views/Trends.vue";
import Cart from "../views/Cart.vue";
import Checkout from "../views/Checkout.vue";
import Product from "../views/Product.vue";
import Categorylist from "../views/Categorylist.vue";
import Search from "../views/Search.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        title: "MB Clothing Ecommerce website",
      },
    },
    {
      path: "/about",
      name: "About",
      component: About,
      meta: {
        title: "MB Clothing - About",
      },
    },
    {
      path: "/trends",
      name: "Trends",
      component: Trends,
      meta: {
        title: "MB Clothing - Trends",
      },
    },
    {
      path: "/cart",
      name: "Cart",
      component: Cart,
      meta: {
        title: "MB Clothing - Cart",
      },
    },
    {
      path: "/checkout",
      name: "Checkout",
      component: Checkout,
      meta: {
        title: "MB Clothing - Checkout",
      },
    },
    {
      path: "/search",
      name: "Search",
      component: Search,
      meta: {
        title: "MB Clothing - Search",
      },
    },
    {
      path: "/product/:id",
      name: "Product",
      component: Product,
      props: true,
      meta: {
        title: "MB Clothing - Product",
      },
    },
    {
      path: "/category/:id",
      name: "Categorylist",
      component: Categorylist,
      props: true,
    },

    {
      path: "/contact",
      name: "Contact",
      component: Contact,
      meta: {
        title: "MB Clothing - Contact",
      },
    },
  ],
});
